import { useEffect, useRef } from 'react';
import {
  CustomEventNamesType,
  prefixEventKey,
} from '@common/services/custom-events';

export function useCustomEvent(
  eventName: CustomEventNamesType,
  callback: () => void
) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const handler = () => callbackRef.current();

    window.addEventListener(prefixEventKey(eventName), handler);
    return () => window.removeEventListener(prefixEventKey(eventName), handler);
  }, [eventName]);
}
